<div class="ap-grid ap-grid-cols-2 ap-grid-cols-sm-1">
    <div>
        @if (anonymous()) {
            <ap-input-skeleton></ap-input-skeleton>
        }
        @if (!anonymous()) {
            <ap-paragraph-skeleton [rows]="10"></ap-paragraph-skeleton>
            <ap-input-skeleton></ap-input-skeleton>
        }
    </div>
</div>
<ap-button-skeleton class="ap-sign__digipas-skeleton_button"></ap-button-skeleton>
